import {
    AutogenLayoutMultipleDocketNumberSelector
} from "@mcleod/powerbroker/src/autogen/AutogenLayoutMultipleDocketNumberSelector";

export class MultipleDocketNumberSelector extends AutogenLayoutMultipleDocketNumberSelector{

}
